import { render } from "./stay.vue?vue&type=template&id=12fdc10e&scoped=true"
import script from "./stay.vue?vue&type=script&lang=js"
export * from "./stay.vue?vue&type=script&lang=js"

import "./stay.vue?vue&type=style&index=0&id=12fdc10e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-12fdc10e"

export default script